import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { CartService } from '@app/_services/cart.service';
import { QuotationCartService } from '@app/_services/quotation.service';
import { ToastRef, ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import * as _ from 'lodash'
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { CurrencyFormatPipe } from '../../shared/pipes/currency-format.pipe';
import { MatButtonModule } from '@angular/material/button';
import { QuotationMessageComponent } from './components/message-information/quotation-messages.component';
import { BookingDetailsViewerComponent } from '../../shared/components/booking-details/booking-details.component';
import { OptionsDetailsViewerComponent } from '../../shared/components/options-details/options-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor, DecimalPipe } from '@angular/common';
@Component({
    selector: 'app-quotation-details',
    templateUrl: './quotation-details.component.html',
    styleUrls: ['./quotation-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, FlexModule, ExtendedModule, RouterLink, MatIconModule, MatTabsModule, NgFor, OptionsDetailsViewerComponent, BookingDetailsViewerComponent, QuotationMessageComponent, MatButtonModule, DecimalPipe, CurrencyFormatPipe, TranslateModule]
})
export class QuotationDetailsComponent {
    userDetails;
    addingToCart: any;
    loading = true;
    constructor(
        private authService: AuthenticationService,
        public quotationCart: QuotationCartService,
        public cart: CartService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private toastr: ToastrService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) {}

    displayedColumns: string[] = [
        'item',
        'amount',
        'unitTotal',
        'itemTotal',
        'discount',
    ];
    items = [];
    quotationDetails;

    status = {
        new: {
            color: '#125077',
            text: 'New',
        },
        open: {
            color: '#9E6DEB',
            text: 'Open',
        },
        offered: {
            color: '#ff5900',
            text: 'Offered',
        },
        accepted: {
            color: '#079008',
            text: 'Accepted',
        },
        inprogress: {
            color: '#6D9EEB',
            text: 'In-Progress',
        },
        rejected: {
            color: '#ff0202',
            text: 'Rejected',
        },

        cancelled: {
            color: '#ff0202',
            text: 'Cancelled',
        },
        renegotiated: {
            color: '#0095a0',
            text: 'Renegotiated',
        },
    };

    _=_
    quotationId;
    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });

        this.activeRoute.params.subscribe((result) => {
            this.quotationId=result.slug
        });

        this.loadQuotationDetails(this.quotationId)
    }

    loadQuotationDetails(id) {
        this.loading = true;
        this.quotationCart.getQuotationDetails(id).subscribe(
            (data) => {
                if (data) {
                    this.loading = false;

                    this.quotationDetails = data.data;
                    this.items = this.quotationDetails?.items;
                    //console.log('QuotationDetails: ' + JSON.stringify(data));
                } else {
                    this.toastr.error('Error getting Data');
                    this.loading = false;
                }
            },
            (error) => {
                this.loading = false;
                this.toastr.error('Error getting Data');
                console.log(error);
            }
        );
    }

    updateQuotationStatus(action){
        this.quotationCart.updateQuotationStatus(action,this.quotationId).subscribe(
            (response) => {


                if(action=='cancel'){
                    this.router.navigate(['/account/quotations']);
                }else{
                    this.loadQuotationDetails(this.quotationId);
                }

                this.toastr.success(response.msg);
                // this.toastr.success('Quotation Canceled.');

            },
            (error) => {
                this.toastr.error('Error Proccessing request');
                console.log(error);
            }
        );
    }

    addToCart(): void {
        if (this.userDetails) {
            if (!this.addingToCart) {
                this.addingToCart = true;
                let cartItem: any = {
                    productId: this.quotationDetails.productId,
                };
                this.cart.addItem(cartItem, this.quotationDetails).subscribe(
                    (data) => {
                        this.toastr.success(`Quotation items added to cart!`);
                        this.addingToCart = false;
                    },
                    (error) => {
                        this.addingToCart = false;
                        this.toastr.error('Error Adding to Cart');
                        console.log('Error Adding to Cart: ', error);
                    }
                );
            }
        } else {
            this.router.navigate(['/login'], {
                queryParams: {
                    returnUrl: this.router.routerState.snapshot.url,
                },
            });
        }
    }

    printQuotation(){
       return this.quotationCart.printQuotation(this.quotationId);
    }
}
